import { ContractStatus } from 'app/modules/contracts/contractTypes';
import { UserStatus } from 'app/types/UserStatus';
import { constantToDisplayName } from "../../constantToDisplayName";
import styled from 'styled-components';
import { Box, TooltipOnHover, tombac } from 'tombac';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const colorSchemesColorMap = {
  'neutral-dark': 'neutral'
};
const colorSchemeGrades = {
  accent: [500, 48],
  alert: [500, 32],
  danger: [500, 16],
  neutral: [600, 16],
  'neutral-dark': [800, 16],
  primary: [500, 16],
  success: [500, 48]
};
const getColorSchemeBaseColor = colorScheme => tombac.color(colorSchemesColorMap[colorScheme] ?? colorScheme, colorSchemeGrades[colorScheme][0]);
const getColorSchemeAlphaColor = colorScheme => tombac.alpha(colorSchemesColorMap[colorScheme] ?? colorScheme, colorSchemeGrades[colorScheme][1]);
export const StatusDot = styled.span.withConfig({
  displayName: "ContractStatusDot__StatusDot"
})(["background-color:", ";border-radius:100%;width:", ";height:", ";display:block;margin:", ";"], ({
  colorScheme
}) => getColorSchemeBaseColor(colorScheme), tombac.unit(8), tombac.unit(8), tombac.unit(3));
export const StatusDotContainer = styled.span.withConfig({
  displayName: "ContractStatusDot__StatusDotContainer"
})(["background-color:", ";border-radius:100%;display:inline-flex;text-align:center;vertical-align:middle;"], ({
  colorScheme
}) => getColorSchemeAlphaColor(colorScheme));
export const DescribedStatusDot = ({
  colorScheme,
  statusName,
  ...stylingProps
}) => /*#__PURE__*/_jsxs(Box, {
  ...stylingProps,
  "data-sentry-element": "Box",
  "data-sentry-component": "DescribedStatusDot",
  "data-sentry-source-file": "ContractStatusDot.tsx",
  children: [' ', /*#__PURE__*/_jsx(TooltipOnHover, {
    content: statusName,
    placement: "top",
    size: "s",
    variant: "default",
    "data-sentry-element": "TooltipOnHover",
    "data-sentry-source-file": "ContractStatusDot.tsx",
    "data-sentry-element": "TooltipOnHover",
    children: /*#__PURE__*/_jsx(StatusDotContainer, {
      colorScheme: colorScheme,
      "data-sentry-element": "StatusDotContainer",
      "data-sentry-source-file": "ContractStatusDot.tsx",
      "data-sentry-element": "StatusDotContainer",
      children: /*#__PURE__*/_jsx(StatusDot, {
        colorScheme: colorScheme,
        "data-sentry-element": "StatusDot",
        "data-sentry-source-file": "ContractStatusDot.tsx",
        "data-sentry-element": "StatusDot"
      })
    })
  })]
});
const statusUserColorsMap = {
  [UserStatus.Active]: 'success',
  [UserStatus.Inactive]: 'neutral',
  [UserStatus.Locked]: 'neutral-dark',
  [UserStatus.Deleted]: 'danger'
};
export const UserStatusDot = ({
  status,
  ...stylingProps
}) => {
  if (!status) return null;
  const statusName = constantToDisplayName(status);
  const colorScheme = statusUserColorsMap[status];
  return /*#__PURE__*/_jsx(DescribedStatusDot, {
    ...stylingProps,
    colorScheme: colorScheme,
    statusName: statusName,
    "data-sentry-element": "DescribedStatusDot",
    "data-sentry-component": "UserStatusDot",
    "data-sentry-source-file": "ContractStatusDot.tsx"
  });
};
const statusColorMapping = {
  [ContractStatus.Active]: 'success',
  [ContractStatus.Upcoming]: 'alert',
  [ContractStatus.Expired]: 'neutral'
};
export const ContractStatusDot = ({
  status,
  ...stylingProps
}) => {
  if (!status) return null;
  const statusName = constantToDisplayName(status);
  const colorScheme = statusColorMapping[status];
  return /*#__PURE__*/_jsx(DescribedStatusDot, {
    ...stylingProps,
    colorScheme: colorScheme,
    statusName: statusName,
    "data-sentry-element": "DescribedStatusDot",
    "data-sentry-component": "ContractStatusDot",
    "data-sentry-source-file": "ContractStatusDot.tsx"
  });
};
export default ContractStatusDot;